import React from 'react';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router-dom';

import { authResetPasswordStageSelector } from 'state/auth/selectors';
import { ResetPasswordStage } from 'state/auth/reducer';

import { PhoneForm } from 'pages/ResetPassword/components/PhoneForm';
import { CodeForm } from 'pages/ResetPassword/components/CodeForm';
import { PasswordForm } from 'pages/ResetPassword/components/PasswordForm';

import { AuthHeader } from 'pages/Login/components/AuthHeader';

export const ResetPasswordForm = () => {
    const currentForm = useSelector(authResetPasswordStageSelector);
    switch (currentForm) {
        case ResetPasswordStage.PHONE:
            return <PhoneForm />;
        case ResetPasswordStage.CODE:
            return <CodeForm />;
        case ResetPasswordStage.PASSWORD:
            return <PasswordForm />;
    }
};

const useStyles = makeStyles(theme => ({
    container: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
    },
    title: {
        flexGrow: 0,
        flexBasis: 'auto',
    },
    contents: {
        flex: 1,
    },
}));

export const ResetPassword = () => {
    const classes = useStyles();
    const history = useHistory();
    return (
        <div className={classes.container}>
            <AuthHeader onBack={() => history.goBack()} />
            <div className={classes.contents}>
                <ResetPasswordForm />
            </div>
        </div>
    );
};
